export default __webpack_public_path__ + "static/media/gallery-wip-emitter_01.302d4b59.jpg";